module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-sleet-fill-5a1f9b93.svg";